import { render, staticRenderFns } from "./FootbowlField.vue?vue&type=template&id=658c9845&scoped=true&"
import script from "./FootbowlField.vue?vue&type=script&lang=ts&"
export * from "./FootbowlField.vue?vue&type=script&lang=ts&"
import style0 from "./FootbowlField.vue?vue&type=style&index=0&id=658c9845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c9845",
  null
  
)

component.options.__file = "FootbowlField.vue"
export default component.exports